import type { RouteObject } from 'react-router-dom';

import PagePremission from '@/routes/Restrictions/PagePremission';
import { lazyRouteComponent } from '@/utils/lazyLoad';
import SolovitPremissions from '@/utils/premissions/solovitPremissons.enum';

// Lazy load Solovit components
const SolovitSettings = lazyRouteComponent(
  () => import('@/pages/Solovit/Settings'),
);
const SolovitDebtsByAreas = lazyRouteComponent(
  () => import('@/pages/Solovit/DebtsByAreas'),
);
const SolovitInvoices = lazyRouteComponent(
  () => import('@/pages/Solovit/Invoices'),
);
const SolovitOpenInvoices = lazyRouteComponent(
  () => import('@/pages/Solovit/Invoices/OpenInvoices'),
);
const SolovitClosedInvoices = lazyRouteComponent(
  () => import('@/pages/Solovit/Invoices/ClosedInvoices'),
);
const SolovitAreas = lazyRouteComponent(() => import('@/pages/Solovit/Areas'));
const SalesStatistics = lazyRouteComponent(
  () => import('@/pages/Solovit/SalesStatistics'),
);

// Define Solovit routes with permission checks
const SolovitRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <PagePremission prem={SolovitPremissions.Prem_Solovit_Invoices}>
        <SolovitInvoices />
      </PagePremission>
    ),
  },
  {
    path: 'settings',
    element: (
      <PagePremission prem={SolovitPremissions.Prem_Solovit_View}>
        <SolovitSettings />
      </PagePremission>
    ),
  },

  {
    path: 'debts-by-areas',
    element: (
      <PagePremission prem={SolovitPremissions.Prem_Solovit_View}>
        <SolovitDebtsByAreas />
      </PagePremission>
    ),
  },
  {
    path: 'invoices/open',
    element: (
      <PagePremission prem={SolovitPremissions.Prem_Solovit_Invoices}>
        <SolovitOpenInvoices />
      </PagePremission>
    ),
  },
  {
    path: 'invoices/closed',
    element: (
      <PagePremission prem={SolovitPremissions.Prem_Solovit_Invoices}>
        <SolovitClosedInvoices />
      </PagePremission>
    ),
  },
  {
    path: 'areas',
    element: (
      <PagePremission prem={SolovitPremissions.Prem_Solovit_View}>
        <SolovitAreas />
      </PagePremission>
    ),
  },
  {
    path: 'sales-statistics',
    element: (
      <PagePremission prem={SolovitPremissions.Prem_Solovit_Invoices}>
        <SalesStatistics />
      </PagePremission>
    ),
  },
];

export default SolovitRoutes;
